import type { SetStateAction, Dispatch } from "react";

/**
 * Given a setState function on an object, this function returns a function
 * that toggles a prop on the state object true/false.
 *
 * @example
 * const [formState, setFormState] = React.useState({ required: false });
 * <Checkbox id="name" checked={formState.required} onChange={toggleStateNode(setFormState, "required")} />
 */
export function toggleStateNode<
  T extends {},
  K extends { [K in keyof T]: T[K] extends boolean ? K : never }[keyof T]
>(setState: Dispatch<SetStateAction<T>>, node: K) {
  return () => {
    setState((oldState) => {
      return {
        ...oldState,
        [node]: !oldState?.[node],
      };
    });
  };
}
